import { IntlMessageFormat } from 'intl-messageformat';
import { EN_MESSAGES, CS_MESSAGES, REGISTRY } from './catalog.js';
import { fallbackChain } from './keys.js';
import { productMessageValues } from './product.js';
function lookup(catalog, key) {
    let node = catalog;
    for (const part of key.split('.')) {
        if (typeof node === 'string')
            return undefined;
        const next = node[part];
        if (next === undefined)
            return undefined;
        node = next;
    }
    return typeof node === 'string' ? node : undefined;
}
const formatCache = new Map();
function formatMessage(pattern, locale, values) {
    const cacheKey = `${locale}\u0000${pattern}`;
    let formatter = formatCache.get(cacheKey);
    if (formatter === undefined) {
        // `ignoreTag: true`: `t()` vraci STRING, takze rich-text tagy ICU
        // (`<a>…</a>` s tovarnami na elementy) tu nejdou pouzit tak jako tak —
        // bez tohoto prepinace kazda zprava s `<…>` skonci `SyntaxError:
        // INVALID_TAG` (nalez kroku C2: `webAdmin.mapPreview.attribution`
        // s povinnou atribuci dlazdic padala pri kazdem vykresleni mapy).
        formatter = new IntlMessageFormat(pattern, locale, undefined, { ignoreTag: true });
        formatCache.set(cacheKey, formatter);
    }
    return formatter.format(values);
}
/** Prelozi typovany klic do jazyka kontextu s fallback retezi. */
export function t(key, options = {}) {
    const callerValues = options.values ?? {};
    for (const locale of fallbackChain(options.locale)) {
        const primary = locale.split('-')[0] ?? locale;
        for (const candidate of new Set([locale, primary])) {
            const catalog = REGISTRY.get(candidate);
            if (catalog === undefined)
                continue;
            const pattern = lookup(catalog, key);
            if (pattern !== undefined) {
                // Krok BRAND1: `{app}`/`{appDomain}` (jmeno a domena produktu)
                // doplnuje preklad sam — volajici je nepreda nikdy. Tvary se berou
                // podle jazyka KATALOGU (cestina sklonuje), ne podle pozadovaneho
                // locale, stejne jako pluralova pravidla nize. Hodnoty volajiciho
                // jsou az za nimi, takze nic existujiciho neprepisou.
                const values = { ...productMessageValues(candidate), ...callerValues };
                // ICU vzdy formatujeme v jazyce katalogu (pluralova pravidla).
                return formatMessage(pattern, candidate, values);
            }
        }
    }
    throw new Error(`i18n: chybi klic '${key}' ve vsech jazycich fallback reteze`);
}
/**
 * Bezpecna varianta - vrati undefined misto vyjimky (pro volitelne texty,
 * napr. popisky flagu spravovane za behu).
 */
export function tryT(key, options = {}) {
    try {
        return t(key, options);
    }
    catch {
        return undefined;
    }
}
export { CS_MESSAGES, EN_MESSAGES };
//# sourceMappingURL=translate.js.map